// generated from 86_157 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const receivedWorkflowStepFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("received_workflow_step_filter"),
  comparison_key: z.enum([
    "7", // 44_403 (51.54%)
    "8", // 41_754 (48.46%)
  ]),
  display_name: z.string(),
  // undefined: 86_150 (99.99%), defined 7 (0.01%)
  has_hard_deleted_data: z.literal(true).optional(),
  // undefined: 33_189 (38.52%), defined 52_968 (61.48%)
  raw_value: common.objectId.optional(),
  value: z.object({
    id: common.objectId,
    // undefined: 7 (0.01%), defined 86_150 (99.99%)
    pre_filter_value: z
      .object({
        // true 19_053 (22.12%), false 67_097 (77.88%)
        expired: z.boolean(),
        id: common.objectId,
        value: z.string(),
      })
      .optional(),
    value: z.string(),
  }),
  varies_by_app_group: z.literal(true),
});
